import { useCreation, useRequest } from 'ahooks'
import { Cascader } from 'antd'
import { isNil, last } from 'lodash'

import { queryChannelTreeApi } from '@eastcoal/api/trade/channel/queryChannelTree'
import { ChannelTreeDetail } from '@eastcoal/api/trade/interface'

import { DataEmpty } from '@eastcoal/common/components/DataEmpty'
import { DataError } from '@eastcoal/common/components/DataError'
import { findTreePaths } from '@eastcoal/common/utils/array'

import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import { ChannelCascaderProps } from './interface'

const fieldNames = {
  value: 'id',
  label: 'name',
  children: 'children'
} as const

const Component = ({
  value,
  onChange,
  type,
  ...restProps
}: ChannelCascaderProps) => {
  const { data, error, loading, refreshAsync } = useRequest(
    () =>
      queryChannelTreeApi({
        enable: true,
        type
      }),
    {
      manual: false,
      ready: !isNil(type),
      refreshDeps: [type]
    }
  )

  const selectedKeys = useCreation(() => {
    if (isNil(data)) {
      return undefined
    }

    if (isNil(value)) {
      return undefined
    }

    const nodes = findTreePaths(data, node => node.id === value.id)
    return nodes.map(node => `${node.id}`)
  }, [data, value])

  const handleChange = (_: unknown, options: ChannelTreeDetail[]) => {
    onChange?.(last(options))
  }

  return error ? (
    <DataError error={error} loading={loading} reload={refreshAsync} />
  ) : (
    <Cascader
      changeOnSelect
      expandTrigger='hover'
      fieldNames={fieldNames}
      loading={loading}
      multiple={false}
      notFoundContent={<DataEmpty loading={loading} reload={refreshAsync} />}
      options={data}
      placeholder='请选择频道'
      value={selectedKeys}
      onChange={handleChange}
      {...restProps}
    />
  )
}

export const ChannelCascader = connect(
  Component,
  mapReadPretty(Component, {
    disabled: true
  })
)
